import { AbstractPaginator } from './abstract-paginator';

export class ClientPaginator<T> extends AbstractPaginator{
  public items: T[];

  constructor(items: T[] = []) {
    super();
    this.items = this.uniqueArray(items);
  }

  public get currentPage(): T[] {
    if (!this.items) {
      return null;
    }
    const startIndex = this.page * this.size;
    const endIndex = startIndex + this.size;
    return this.items.slice(startIndex, endIndex);
  }

  public get pages(): number {
    if (this.items.length === 0) {
      return 1;
    }
    return Math.ceil(this.items.length / this.size);
  }

  public get numberElements(): number {
    return this.items?.length;
  }

  public add(item: T) {
    this.items = this.uniqueArray([...this.items, item]);
  }

  public remove(item: T): void {
    this.items = this.items.filter(pItem => pItem !== item);
  }

  private uniqueArray(items: T[]): T[] {
    return !items ? undefined : Array.from(new Set<T>(items));
  }
}
